import { render, staticRenderFns } from "./salonDetail.vue?vue&type=template&id=6930be3a&scoped=true&"
import script from "./salonDetail.vue?vue&type=script&lang=js&"
export * from "./salonDetail.vue?vue&type=script&lang=js&"
import style0 from "./salonDetail.vue?vue&type=style&index=0&id=6930be3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930be3a",
  null
  
)

export default component.exports